export default __webpack_public_path__ + "img/599b41d1670a235dd06b6270900ea88d.svg";